import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGet } from "utils/apiFetch";
import pathObj from "utils/apiPath";

function Notifications() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [canLoadMore, setCanLoadMore] = useState(false);
  const { setHasNewNotification } = useContext(AuthContext);

  const handleScroll = useCallback(() => {
    const bottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 5;
    if (bottom && !loading && canLoadMore) {
      setPage((prev) => prev + 1);
    }
  }, [loading, canLoadMore]);

  useEffect(() => {
    const getNotifications = async () => {
      setLoading(true);
      try {
        const path = pathObj.getNotifications;
        const result = await apiGet(path, { page, page_size: 10 });
        setNotifications([...notifications, ...result.data.results.docs]);
        setCanLoadMore(result.data.results.hasNextPage);
      } catch (error) {}
      setLoading(false);
    };

    getNotifications();
    setHasNewNotification(false)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    // clean up code
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <Toolbar title={t("NOTIFICATIONS")} showBackBtn={true} />
      <div className="flex flex-col w-full justify-center items-center">
        <div className="w-full md:w-[25rem] mt-3 p-4 overflow-y-auto">
          {notifications.map((it) => (
            <div key={it._id} className="bg-card p-4 flex justify-start items-center gap-3 mb-3 cursor-pointer">
              <FontAwesomeIcon icon={faBell} size="xl" className="text-white" />
              <div className="w-full flex justify-between items-center">
                <div className="flex flex-col">
                  <span className="text-white font-medium">{it.title}</span>
                  <span className="text-white font-medium">{it.body}</span>
                </div>
                <span className="text-white font-medium text-end">{dayjs(it.createdAt).format("DD-MM-YYYY hh:mm A")}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Notifications;
